<template>
  <div id="app">
    <header class="header">
      <div class="container">
        <div class="header-content">
          <div>
            <h1>{{ t('app.title') }}</h1>
            <p class="subtitle">{{ t('app.subtitle') }}</p>
          </div>
        </div>
      </div>
    </header>
    
    <main class="container">
      
      <IPInfoDetector />
      <BrowserInfoDetector />
      <NetworkSecurityTools />
      
    </main>
    
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <p class="copyright">{{ t('app.footer.copyright') }}</p>
          <LanguageSwitcher />
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import IPInfoDetector from './components/IPInfoDetector.vue'
import BrowserInfoDetector from './components/BrowserInfoDetector.vue'
import NetworkSecurityTools from './components/NetworkSecurityTools.vue'
import LanguageSwitcher from './components/LanguageSwitcher.vue'

export default {
  name: 'App',
  components: {
    IPInfoDetector,
    BrowserInfoDetector,
    NetworkSecurityTools,
    LanguageSwitcher
  },
  setup() {
    const { t } = useI18n();
    
    return {
      t
    };
  }
}
</script>

<style>
/* 全局样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 2px;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #f0f2f5;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* 头部样式 */
.header {
  background-color: #867EFF;
  color: white;
  padding: 20px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header h1 {
  font-size: 2.2rem;
  margin-bottom: 10px;
}

.subtitle {
  font-size: 1.1rem;
  opacity: 0.9;
}

/* 主内容区域样式 */
main.container {
  padding: 15px 10px;
}


/* 内容区域 */
.content-section {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 15px;
  margin-bottom: 20px;
}

.section-title {
  color: #1e3a8a;
  font-size: 1.5rem;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e8f0;
}

/* 页脚样式 */
.footer {
  background-color: #2d3748;
  color: white;
  padding: 20px 0;
  margin-top: 20px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.copyright {
  margin: 0;
}

.disclaimer {
  font-size: 0.9rem;
  opacity: 0.7;
  max-width: 800px;
  margin: 0 auto;
  margin-bottom: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header {
    display: none;
  }

  .section-title {
    font-size: 1.3rem;
    margin-bottom: 15px;
    padding-bottom: 8px;
  }
  
  .content-section {
    padding: 12px;
    margin-bottom: 15px;
  }
  
  main.container {
    padding: 10px 5px;
  }
  
  .container {
    padding: 0 10px;
  }
  
  .footer {
    padding: 15px 0;
    margin-top: 15px;
  }

  .footer-content {
    flex-direction: column;
    gap: 15px;
  }
}
</style>
